import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const SUMTOTALJOBSDIFF_LAYER_ID = 'sumTotalJobsDiffLayer';

const layerConfig = {
  title: 'Sum Total Jobs Diff',
};

function SumTotalJobsDiffLayer() {
  const dispatch = useDispatch();
  const { sumTotalJobsDiffLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, sumTotalJobsDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (sumTotalJobsDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SUMTOTALJOBSDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: sumTotalJobsDiffLayer.visible,
      opacity: sumTotalJobsDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'sum_total_jobs_diff',
        domain: [-14908, -100, -1, 0, 0.01, 100, 107083],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SUMTOTALJOBSDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['sum_total_jobs_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default SumTotalJobsDiffLayer;
